<template>
  <div class="overlay-full overlay-school-feedback">
    <div class="overlay-content" style="top: 15%">
      <div
        class="col-sm-4 mx-auto text-left bg-white pt-1 p-4 border rounded rounded-lg"
      >
        <div class="title d-flex justify-content-between border-bottom mb-2">
          <span class="font-weight-bold">Schools Feedback</span>
          <div class="close-school-feedback">
            <a href="javascript:void(0)" id="school-feedback-close"
              ><i class="far fa-times-circle"></i
            ></a>
          </div>
        </div>
        <form
          class="form-horizontal"
          action="#"
          @submit.prevent="submitSchoolFeedback"
          method="POST"
        >
          <input type="hidden" :value="visitorId" id="feedback-visitor-id" />
          <input type="hidden" :value="schoolId" id="feedback-school-id" />
          <div class="form-group row">
            <div class="col-sm-12">
              <label class="font-weight-bold" for="feedback-visitor-name"
                >Visitor Name</label
              >
              <input
                class="form-control"
                type="text"
                readonly
                value=""
                id="feedback-visitor-name"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12">
              <label class="font-weight-bold" for="feedback-visitor-type"
                >Visitor Type</label
              >
              <input
                class="form-control"
                type="text"
                readonly
                value=""
                id="feedback-visitor-type"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12">
              <label class="font-weight-bold" for="feedback-user-branch"
                >Branch</label
              >
              <input
                class="form-control"
                type="text"
                readonly
                value=""
                id="feedback-user-branch"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12">
              <label class="font-weight-bold" for="feedback-visitor-phone"
                >Phone</label
              >
              <input
                class="form-control"
                type="text"
                readonly
                value=""
                id="feedback-visitor-phone"
              />
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12">
              <label class="font-weight-bold" for="feedback-visitor-schools"
                >School</label
              >
              <select
                ref=""
                class="form-control"
                id="feedback-visitor-schools"
              ></select>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-sm-12">
              <button
                class="btn btn-primary col-12 mt-1"
                type="submit"
                :disabled="isButtonDisabled"
              >
                Send School Feedback
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import _ from "lodash";
export default {
  name: "OverlaySchoolFeedback",
  data() {
    return {
      schoolId: "",
      visitorId: "",
      visitorType: "",
      isButtonDisabled: false,
    };
  },
  methods: {
    submitSchoolFeedback: _.debounce(
      async function () {
        this.schoolId = $($("#feedback-visitor-schools").select2()).val();
        this.visitorId = $("#feedback-visitor-id").val();
        this.visitorType = $("#feedback-visitor-type").val();

        if (this.schoolId !== "") {
          if (!this.isButtonDisabled) {
            this.isButtonDisabled = true;
            axios
              .post(
                `/admin/send-school-feedback/${this.visitorType}/${this.visitorId}/${this.schoolId}`
              )
              .then((res) => {
                if (res.data.success) {
                  new Noty({
                    type: "success",
                    text: res.data.message,
                  }).show();
                } else {
                  new Noty({
                    type: "danger",
                    text: res.data.message,
                  }).show();
                }
                this.isButtonDisabled = false;
              })
              .catch((err) => {
                this.isButtonDisabled = false;
                console.log(err);
              });
          }
        } else {
          this.isButtonDisabled = false;
          new Noty({
            type: "danger",
            text: "Please select the school first",
          }).show();
        }
      },
      500,
      { leading: true, trailing: true }
    ),
  },
};
</script>